/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { useReducer } from "react";
import "./style.css";
import { useState } from 'react';

export const StateDefaultWrapper = ({
  stateProp,
  className,
  iconPerson = "/img/icon-person.png",
  text = "Campo de texto",
  onInputChange,
}) => {
  const [password, setPassword] = useState('');

  const [state, dispatch] = useReducer(reducer, {
    state: stateProp || "default",
  });
    


  return (
    <div
      className={`state-default-wrapper state-0-${state.state} ${className}`}
      onMouseEnter={() => {
        dispatch("mouse_enter");
      }}
      onClick={() => {
        dispatch("click");
      }}
      onMouseLeave={() => {
        dispatch("mouse_leave");
      }}
    >
      {["error", "state-6"].includes(state.state) && (
        <div className="div">
          {state.state === "error" && <>***********</>}

          {state.state === "state-6" && <>Secret12345</>}
        </div>
      )}

      
      
      {["active-hidden", "active-showing", "default", "hover"].includes(state.state) && (
        <div className="campo-de-texto-2">
          {["default", "hover"].includes(state.state) && <>{text}</>}
          <input className="entrada-de-texto"
          type={state.state === "active-showing" ? 'text' : 'password'}
          value={password}
          onChange={(e) => {
            const password = e.target.value;
            setPassword(password);
            onInputChange(password);
            }
          }
          onFocus={(e) => {
            e.target.click();
            }
          }
          onBlur={(e) => {
            if (e.target.value === "") {
              dispatch("empty");
            }
            
            }
          }
          />
          
          
        </div>

      )}

      <img
            className="vector-2"
            onClick={(event) => {
              dispatch("show-hidden-password");
              event.stopPropagation();
            }}
            alt="Vector"
            src={
              state.state === "state-6"
                ? "/img/vector-1.svg"
                : state.state === "default"
                ? iconPerson
                : state.state === "hover"
                ? "/img/icon-person-5.png"
                : state.state === "active-hidden"
                ? "/img/vector-4.svg"
                : state.state === "active-showing"
                ? "/img/vector-3.svg"
                : "/img/vector-2.svg"
            }
      />
      
    </div>
  );
};

function reducer(state, action) {
  if (action === "empty") {
    return {
          state: "default",
        };
  }
  
  if (state.state === "default") {
    switch (action) {
      case "mouse_enter":
        return {
          state: "hover",
        };

      case "click":
        return {
          state: "active-showing",
        };

    }
  }

  if (state.state === "hover") {
    switch (action) {
      case "mouse_leave":
        return {
          state: "default",
        };

      case "click":
        return {
          state: "active-hidden",
        };
    }
  }

  if (state.state === "active-showing") {
    switch (action) {
      case "show-hidden-password":
        return {
          state: "active-hidden",
        };
    }
  }

  if (state.state === "active-hidden") {
    switch (action) {
      case "show-hidden-password":
        return {
          state: "active-showing",
        };
    }
  }


  return state;
}

StateDefaultWrapper.propTypes = {
  stateProp: PropTypes.oneOf(["state-6", "active-showing", "default", "hover", "active-hidden", "error"]),
  iconPerson: PropTypes.string,
  text: PropTypes.string,
};
